'use strict';

angular.module('msLegacyActivities').controller('ActivitySearchPageCtrl', ['$stateParams', 'NotifyingSvc', '$scope', 'activitySvc', 'context', function ($stateParams, NotifyingSvc, $scope, activitySvc, context) {
  var vm = this;
  vm.params = $stateParams;

  if ($stateParams.data) {
    loadData($stateParams.data);
  } else if ($stateParams.query) {
    // a search query exists, but hasn't been executed yet
    // this is usually hit when a user leaves a search page,
    // but returns using the back button.
    var searchBody = {
      query: $stateParams.query,
      context: context,
      filters: null
    };
    activitySvc.search(searchBody);
  }

  $scope.$watch($stateParams.data, function (data) {
    vm.emptySearch = data && data.records.length > 0;
  });

  NotifyingSvc.subscribe(NotifyingSvc.EVENTS.SEARCH_RESULTS, function (event, data) {
    vm.searchPending = false;
    loadData(data);
  });

  function loadData(data) {
    vm.query = data.query;
    vm.hits = data.hits;
    vm.records = data.records;
  }
}]);